// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2mqAd","colCheckbox":"styles_colCheckbox__110sj"};